import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { useDrag, useDrop } from 'react-dnd';

import { useClassName } from 'hooks/useClassName';

const Dots = () => {
  const c = useClassName('dragCard');

  return (
    <div {...c('icon')}>
      {[...Array(6).keys()].map((key) => (
        <div key={key} {...c('dot', key)} />
      ))}
    </div>
  );
};

const DragCard = ({ text, index, moveListItem }) => {
  const c = useClassName('dragCard');

  const ref = useRef();

  const [{ isDragging }, dragRef] = useDrag({
    type: 'item',
    item: { index },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  });

  const [, dropRef] = useDrop({
    accept: 'item',
    hover: (item, monitor) => {
      if (ref.current === undefined) return;

      const itemRef = item;

      const { top, bottom } = ref.current.getBoundingClientRect() || {};
      const hoverMiddleY = (bottom - top) / 2;
      const hoverActualY = monitor.getClientOffset().y - top;

      if (itemRef.index < index && hoverActualY < hoverMiddleY) return;
      if (itemRef.index > index && hoverActualY > hoverMiddleY) return;

      if (item.index !== index) {
        moveListItem(item.index, index);
        itemRef.index = index;
      }
    },
  });

  const dragDropRef = dragRef(dropRef(ref));

  return (
    <div {...c(undefined, { isDragging })} ref={dragDropRef}>
      <Dots />
      <span className="copy">{text}</span>
    </div>
  );
};

export default DragCard;

DragCard.propTypes = {
  text: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
  moveListItem: PropTypes.func.isRequired,
};
